"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuggestionsAndLinksLink = exports.SuggestionsAndLinksButton = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const reactstrap_1 = require("reactstrap");
const SuggestionsAndLinksButtonAndLinkCommonStyle = (0, styled_components_1.css) `
    padding: 1rem;
    outline: none;
    font-size: 16px;
    color: #ffffff;
    background-color: rgba(var(--primeiro), 1);
    width: 100%;
    border-radius: 16px;
    box-shadow: 15px 10px 20px -13px rgba(var(--primeiro), 1), -20px -10px 20px -10px rgba(var(--preto), 0.1), inset 3px 3px 10px 5px rgba(255, 255, 255, 0.5);
`;
exports.SuggestionsAndLinksButton = (0, styled_components_1.default)(reactstrap_1.Button) `
    ${SuggestionsAndLinksButtonAndLinkCommonStyle}
`;
exports.SuggestionsAndLinksLink = styled_components_1.default.a `
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    text-decoration: none;
    &:hover{
        background-color: #6c757d;
        color: #fff;
    }
    ${SuggestionsAndLinksButtonAndLinkCommonStyle}
`;
